import { render, staticRenderFns } from "./DurationSelector.vue?vue&type=template&id=0179b596&scoped=true&"
import script from "./DurationSelector.vue?vue&type=script&lang=js&"
export * from "./DurationSelector.vue?vue&type=script&lang=js&"
import style0 from "./DurationSelector.vue?vue&type=style&index=0&id=0179b596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179b596",
  null
  
)

export default component.exports